(() => {
  const closeSuccess = modal => modal.querySelector('.close-modal')?.click();
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-fm-close-cart]');
    if (close) {
      const dialog = close.closest('dialog');
      if (dialog) dialog.close();
      else {
        const modal = close.closest('[data-ajax-cart-success]');
        if (modal) closeSuccess(modal);
      }
    }
    const link = event.target.closest('[data-fm-personalize-link]');
    if (link) {
      const form = document.getElementById('add-to-cart-form');
      if (!form) return;
      event.preventDefault();
      form.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      form.querySelector('[data-fm-personalization-heading]')?.focus({preventScroll: true});
    }
  });
  const initialize = (root = document) => {
    root.querySelectorAll('[data-fm-personalize-bar]').forEach(bar => {
      if (bar.dataset.ready) return;
      const form = document.getElementById('add-to-cart-form');
      if (!form || !window.IntersectionObserver) return;
      bar.dataset.ready = 'true';
      const observer = new IntersectionObserver(entries => {
        bar.hidden = entries[0].isIntersecting;
      });
      observer.observe(form.querySelector('#product-add-to-cart') || form);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(form) || event.target.contains(bar)) observer.disconnect();
      }, {once: true});
    });
    root.querySelectorAll('[data-fm-selected-package]').forEach(label => {
      if (label.dataset.ready) return;
      label.dataset.ready = 'true';
      const form = label.closest('form');
      const update = () => {
        const selector = form.querySelector('select[name="id"]');
        if (selector?.selectedOptions.length) label.querySelector('span').textContent = selector.selectedOptions[0].textContent.trim();
      };
      form.addEventListener('change', () => setTimeout(update, 0));
      update();
    });
    root.querySelectorAll('[data-ajax-cart-success]').forEach(modal => {
      if (modal.dataset.fmAccessible) return;
      modal.dataset.fmAccessible = 'true';
      let returnFocus;
      const content = modal.querySelector('.halo-modal-content');
      const observer = new MutationObserver(() => {
        if (getComputedStyle(modal).display !== 'none') {
          if (!content.contains(document.activeElement)) {
            returnFocus = document.activeElement;
            content.querySelector('.close-modal')?.focus();
          }
          document.documentElement.classList.add('fm-success-open');
        } else {
          document.documentElement.classList.remove('fm-success-open');
          if (returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
        }
      });
      observer.observe(modal, {attributes: true, attributeFilter: ['style']});
      modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); closeSuccess(modal); }
        if (event.key === 'Tab') {
          const focusable = [...content.querySelectorAll('a[href], button, input, [tabindex="0"]')].filter(element => !element.disabled && element.getClientRects().length);
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
